import * as Sentry from '@sentry/react';
import appConfig, { environment, isProduction } from '@sdk/config/appConfig';

const initSentryReact = (
  sentryEnabled: boolean,
  userId: number = null,
  orgId: number = null
): void => {
  // Initialize Sentry if:
  // - SENTRY_DSN is defined
  // - sentryEnabled is true
  if (appConfig.SENTRY_DSN && sentryEnabled) {
    Sentry.init({
      dsn: appConfig.SENTRY_DSN,
      environment: environment,
      // In production, only send explicitly-dispatched captureMessage /
      // captureException calls. Disabling the default integrations turns off
      // automatic capture (global errors, unhandled rejections) that would
      // otherwise blow through our Sentry error budget. Preproduction keeps
      // full auto-capture.
      ...(isProduction ? { defaultIntegrations: false } : {}),
    });

    if (userId || orgId) {
      Sentry.setUser({
        id: userId,
        orgId: orgId,
      });
    }
  }
};

export default initSentryReact;
